'use client';

import { c as _c } from "react/compiler-runtime";
import { Popover } from '@base-ui/react/popover';
import { reactive } from '@legendapp/state/react';
import { type MouseEventHandler } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Typography } from '@/components/Typography';
import { HeroBlockSearchCard, type HeroBlockSearchCardProps } from '@/components/forms/HeroBlockSearchCard';
import { useHeroBlockSearchFormState } from '@/components/forms/HeroBlockSearchForm/HeroBlockSearchFormProvider';
import { HeroSearchFormColumn, type HeroSearchFormColumnProps } from '@/components/forms/HeroBlockSearchForm/components/HeroSearchFormColumn';
import { cn } from '@/lib/cn';
import { motionFadeUp } from '@/styles/motionAnimations';
export interface HeroSearchFormColumnButtonProps extends HeroSearchFormColumnProps {
  title: string;
  description: string;
  hasBackArrow?: boolean;
  showBack?: boolean;
  onBack?: MouseEventHandler<HTMLButtonElement>;
  cardProps?: Omit<HeroBlockSearchCardProps, 'title' | 'showBack' | 'onBack'>;
}
const ReactiveHeroBlockSearchCard = reactive(HeroBlockSearchCard);
export function HeroSearchFormColumnButton(t0) {
  const $ = _c(32);
  let cardProps;
  let children;
  let className;
  let description;
  let onBack;
  let props;
  let showBack;
  let title;
  if ($[0] !== t0) {
    const {
      title: t1,
      description: t2,
      className: t3,
      children: t4,
      hasBackArrow,
      showBack: t5,
      onBack: t6,
      cardProps: t7,
      ...t8
    } = t0;
    title = t1;
    description = t2;
    className = t3;
    children = t4;
    showBack = t5;
    onBack = t6;
    cardProps = t7;
    props = t8;
    $[0] = t0;
    $[1] = cardProps;
    $[2] = children;
    $[3] = className;
    $[4] = description;
    $[5] = onBack;
    $[6] = props;
    $[7] = showBack;
    $[8] = title;
  } else {
    cardProps = $[1];
    children = $[2];
    className = $[3];
    description = $[4];
    onBack = $[5];
    props = $[6];
    showBack = $[7];
    title = $[8];
  }
  const {
    popover,
    variant$
  } = useHeroBlockSearchFormState();
  let t1;
  if ($[9] !== className) {
    t1 = cn("bg-white hover:bg-primary-accent input-focus-transition btn rounded-none flex-1 items-start", className);
    $[9] = className;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  let t2;
  if ($[11] !== cardProps?.className || $[12] !== variant$) {
    t2 = () => {
      const variant = variant$.get();
      return cn("w-dvw lg:w-auto lg:min-w-94 h-[calc(100dvh-2rem)] lg:h-125 lg:min-h-12 [&_.card-body]:pt-5 m-0", {
        "lg:h-137": variant === "vertical"
      }, cardProps?.className);
    };
    $[11] = cardProps?.className;
    $[12] = variant$;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  let t3;
  if ($[14] !== cardProps || $[15] !== children || $[16] !== onBack || $[17] !== showBack || $[18] !== t2 || $[19] !== title) {
    t3 = <ReactiveHeroBlockSearchCard {...cardProps} title={title} $className={t2} showBack={showBack} onBack={onBack}>{children}</ReactiveHeroBlockSearchCard>;
    $[14] = cardProps;
    $[15] = children;
    $[16] = onBack;
    $[17] = showBack;
    $[18] = t2;
    $[19] = title;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  let t4;
  if ($[21] !== title) {
    t4 = <Typography variant="caption" as="div" className="text-base-content/60">{title}</Typography>;
    $[21] = title;
    $[22] = t4;
  } else {
    t4 = $[22];
  }
  let t5;
  if ($[23] !== description) {
    t5 = <AnimatePresence mode="popLayout" initial={false}><Typography variant="paragraph-heavy" as={motion.div} key={description} className="truncate max-w-full" {...motionFadeUp}>{description}</Typography></AnimatePresence>;
    $[23] = description;
    $[24] = t5;
  } else {
    t5 = $[24];
  }
  let t6;
  if ($[25] !== popover || $[26] !== props || $[27] !== t1 || $[28] !== t3 || $[29] !== t4 || $[30] !== t5) {
    t6 = <HeroSearchFormColumn as={Popover.Trigger} tabIndex={1} className={t1} handle={popover} payload={t3} {...props}>{t4}{t5}</HeroSearchFormColumn>;
    $[25] = popover;
    $[26] = props;
    $[27] = t1;
    $[28] = t3;
    $[29] = t4;
    $[30] = t5;
    $[31] = t6;
  } else {
    t6 = $[31];
  }
  return t6;
}